export default __webpack_public_path__ + "static/media/microsoft.5dc85a80.svg";